export default __webpack_public_path__ + "img/dUaIukcL.bcb8f68b.svg";